import { render, staticRenderFns } from "./ExclusionList.vue?vue&type=template&id=42ca4dd9&"
import script from "./ExclusionList.vue?vue&type=script&lang=js&"
export * from "./ExclusionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports